/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import ImageGallery from '@salesforce/retail-react-app/app/theme/components/project/image-gallery'

export default {
    baseStyle: {
        ...ImageGallery.baseStyle,
        setImage: {
            aspectRatio: 154 / 192,
            htmlWidth: '154',
            htmlHeight: '192',
            width: '154px',
            mixBlendMode: 'multiply',
            height: '192px'
        },
        zoomModel: {
            content: {
                color: 'black.100',
                maxW: '100%',
                padding: '0',
                backgroundColor: 'gray.100'
            },
            mainWrapper: {
                direction: 'column',
                align: 'center',
                justifyContent: 'space-between',
                h: '100vh',
                overflow: 'hidden'
            },
            exitZoom: {
                main: {
                    cursor: 'pointer',
                    backgroundColor: 'black.300',
                    transition: 'all, 0.3s ease',
                    _hover: {
                        backgroundColor: 'black.50'
                    },
                    color: 'white',
                    position: 'absolute',
                    top: '40px',
                    right: '60px',
                    display: 'inline-flex',
                    borderRadius: '90px',
                    padding: '4px 25px',
                    gap: '10px',
                    zIndex: '1'
                },
                text: {
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '22px',
                    letterSpacing: '0.07px'
                }
            },
            leftSection: {
                main: {
                    position: 'absolute',
                    top: '40px',
                    left: '50px',
                    gap: '20px',
                    padding: '15px 14px',
                    display: 'grid'
                },
                text: {
                    fontSize: '17px',
                    fontWeight: '300',
                    lineHeight: '26px',
                    opacity: 0.8,
                    letterSpacing: '0.085px'
                }
            },
            imageView: {
                borderRadius: '51.347px',
                textAlign: 'left',
                margin: 'auto 22.24px auto auto',
                width: 'auto',
                height: 'fit-content',
                background: 'gradientImageView',
                backdropFilter: 'blur(3.469388008117676px)',
                padding: '7px 12px',
                color: 'white',
                lineHeight: 'normal'
            }
        }
    },
    variants: {
        gwp: {
            setImage: {
                aspectRatio: {base: 60 / 74, xs: 106 / 132},
                htmlWidth: {base: '60', xs: '106'},
                htmlHeight: {base: '74px', xs: '132'},
                width: {base: '60px', xs: '106px'},
                height: {base: '74px', xs: '132px'},
                mixBlendMode: 'multiply'
            }
        }
    }
}
